// Response envelope + small utilities shared by every mock route module.
//
//   success -> { success: true,  data, meta?, requestId }
//   error   -> { success: false, error: { code, message, details? }, requestId }

export const mockConfig = { delay: 450, slowDelay: 2500 };

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const requestId = () => `req_${Math.random().toString(36).slice(2, 8)}`;

// Timestamp + random suffix: React 18 StrictMode double-invokes effects in development, so two
// ids minted in the same millisecond must never collide.
export const genId = (prefix) => `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;

export const randomCode = () => String(Math.floor(100000 + Math.random() * 900000));
export const randomToken = () => Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DOMAIN_RE = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i;

export const nowIso = () => new Date().toISOString();

export const ok = (status, data, meta) => ({
  status,
  body: { success: true, data, ...(meta ? { meta } : {}), requestId: requestId() }
});

export const fail = (status, code, message, details) => ({
  status,
  body: { success: false, error: { code, message, ...(details ? { details } : {}) }, requestId: requestId() }
});

export const validationFail = (fields, message = "Some fields contain invalid data.") =>
  fail(422, "VALIDATION_FAILED", message, { fields });

/** "Just now" / "5 min ago" / "3 hr ago" / "02 Oct 2026" — used by list screens. */
export function relativeTime(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  if (!Number.isFinite(diff)) return "";
  const min = Math.floor(diff / 60000);
  if (min < 1) return "Just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export const slugify = (value) => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
